import { render, staticRenderFns } from "./WhatsappShareButton.vue?vue&type=template&id=38508356"
import script from "./WhatsappShareButton.vue?vue&type=script&lang=ts"
export * from "./WhatsappShareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports